
export const storePreconsentData = (decodedPayload, clientCode) => {
    localStorage.setItem('preconsent_loaded_once', 'true');
    localStorage.setItem('preconsent_name', decodedPayload.given_name || '');
    localStorage.setItem('preconsent_surname', decodedPayload.surname || '');
    localStorage.setItem('preconsent_email', decodedPayload.email || '');
    localStorage.setItem('preconsent_phone', decodedPayload.phone || '');
    localStorage.setItem('preconsent_institution', decodedPayload.institution || '');
    localStorage.setItem('preconsent_client', decodedPayload.client || '');
    localStorage.setItem('initialise_consent', 'true');
};

export const clearPreconsentData = () => {
    localStorage.removeItem('preconsent_loaded_once');
    localStorage.removeItem('preconsent_name');
    localStorage.removeItem('preconsent_surname');
    localStorage.removeItem('preconsent_email');
    localStorage.removeItem('preconsent_phone');
    localStorage.removeItem('preconsent_institution');
    localStorage.removeItem('preconsent_client');
    localStorage.removeItem('initialise_consent');
};

export const shouldRedirectToConsent = () => {
    return localStorage.getItem('initialise_consent') === 'true' && 
           localStorage.getItem('preconsent_institution') !== null && 
           localStorage.getItem('preconsent_institution') !== '';
};

export const getPreconsentInstitution = () => {
    return localStorage.getItem('preconsent_institution');
};

export const handleConsentRedirect = (dispatch, institutionSelected) => {
    if (shouldRedirectToConsent()) {
        const institution = getPreconsentInstitution();
        dispatch(institutionSelected(institution, false, true));
        return true; // Indicates redirect happened
    }
    return false; // No redirect
};
